/** Combines one or more space-delimited ARIA ID references without duplicates. */ export function mergeAriaIds(...values) {
    const ids = values.flatMap((value)=>value?.split(/\s+/).filter(Boolean) ?? []);
    return ids.length > 0 ? [
        ...new Set(ids)
    ].join(' ') : undefined;
}
